"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _graphicsDocumentRole = _interopRequireDefault(require("./graphics/graphicsDocumentRole"));
var _graphicsObjectRole = _interopRequireDefault(require("./graphics/graphicsObjectRole"));
var _graphicsSymbolRole = _interopRequireDefault(require("./graphics/graphicsSymbolRole"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ariaGraphicsRoles = [['graphics-document', _graphicsDocumentRole.default], ['graphics-object', _graphicsObjectRole.default], ['graphics-symbol', _graphicsSymbolRole.default]];
var _default = ariaGraphicsRoles;
exports.default = _default;